'use client'

import dynamic from 'next/dynamic'

import { PRIVACY_POLICY_CONFIGURATIONS } from '../../../constants/privacyPolicyConfiguration'
import { RegistryOrigin } from '../../../constants/registry'
import { usePrivacyPolicyVariations } from '../../../utils/privacyPolicyVariations/client/usePrivacyPolicyVariations'

const PrivacyPolicyVariation1 = dynamic(() =>
	import('./Variations/PrivacyPolicyVariation1').then(
		(mod) => mod.PrivacyPolicyVariation1
	)
)

const PrivacyPolicyVariation2 = dynamic(() =>
	import('./Variations/PrivacyPolicyVariation2').then(
		(mod) => mod.PrivacyPolicyVariation2
	)
)

const PrivacyPolicyVariation3 = dynamic(() =>
	import('./Variations/PrivacyPolicyVariation3').then(
		(mod) => mod.PrivacyPolicyVariation3
	)
)

export const PrivacyPolicy = ({
	origin,
}: {
	readonly origin: RegistryOrigin
}) => {
	const isInCheckout = origin === RegistryOrigin.CHECKOUT
	const variation = usePrivacyPolicyVariations(isInCheckout)

	if (variation === PRIVACY_POLICY_CONFIGURATIONS.VARIATION_1) {
		return <PrivacyPolicyVariation1 />
	}

	if (variation === PRIVACY_POLICY_CONFIGURATIONS.VARIATION_2) {
		return <PrivacyPolicyVariation2 />
	}

	if (variation === PRIVACY_POLICY_CONFIGURATIONS.VARIATION_3) {
		return <PrivacyPolicyVariation3 />
	}

	return null
}
